import { StatsPeriod } from "@/hooks/useEventBasedStats";

interface StatsPeriodFilterProps {
  period: StatsPeriod;
  onChange: (period: StatsPeriod) => void;
}

export function StatsPeriodFilter({ period, onChange }: StatsPeriodFilterProps) {
  const options: { value: StatsPeriod; label: string }[] = [
    { value: 'game', label: 'Game' },
    { value: '1h', label: '1st Half' },
    { value: '2h', label: '2nd Half' },
  ];

  return (
    <div className="flex gap-1 p-1 bg-muted rounded-lg w-fit">
      {options.map(option => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={`px-3 py-1.5 text-xs font-medium rounded-md transition-all ${
            period === option.value
              ? 'bg-background text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
